<div class="dialog-wrapper">
    <!-- Head -->
    <div class="head">
      Update Shipping Methods
      <button mat-icon-button (click)="onClose()" class="custom-mat-icon-button button-close-panel">
        <mat-icon matSuffix svgIcon="ico-close" class="custom-mat-icon ico-size ico-2xs"></mat-icon>
      </button>
    </div>

    <div class="form-row row-shipping-rates" *ngIf="shippingError && isFormReady" >
      <section class="message message-row size size1of1">
        <div class="message-wrapper error">
          <div class="message-inner">
            <p class="message-description">There was an error when trying to retrieve the shipping rates.</p>
          </div>
        </div>
      </section>
    </div>
    <div class="form-row row-shipping-rates" *ngIf="!shippingError && collectionIsEmpty" >
      <section class="message message-row size size1of1">
        <div class="message-wrapper error">
          <div class="message-inner">
            <p class="message-description">There are not shipping services activated.</p>
          </div>
        </div>
      </section>
    </div>
    <app-shipping-method-dropdown *ngIf="!shippingError && isFormReady"
      [shippingError] = shippingError
      [collectionOfShippingMethod] = collectionOfShippingMethod
      [collectionOfShipperHqServices] = collectionOfShipperHqServices
      [isShippingIntegrationEnabled] = true
      [currencySymbol] = data.currencySymbol
      [currencyIso3] = data.currencyIso3
      [shippingAmount] = data.shippingAmount
      [showsShippingAmount] = showShippingAmount
      [fixedShippingRate] = data.fixedShippingRate
      [shippingServiceId] = data.shippingServiceId>
  </app-shipping-method-dropdown>

  <!-- Nav -->
  <div class="nav margin nomargin" *ngIf="isFormReady" >
    <button mat-flat-button (click)="onSubmit()" [disabled]="shippingError || collectionIsEmpty" color="primary" class="mat-button custom-mat-button-primary">Update Method</button>
  </div>
  <!-- skeleton form-sections -->
  <div *ngIf="!isFormReady">
    <skeleton-loader-form [numberOfInputs]=2></skeleton-loader-form>
  </div>
</div>
